import ToolbarItem from "toolbar/ToolbarItem";
import $ from "jquery";


class ToolbarItemList extends ToolbarItem {
    constructor(text, items, icon = '') {
        super();
        this.text = text;
        this.items = items;
        this.icon = icon;
        this.isOpen = false;
    }

    getText() {
        return this.text;
    }

    handleClick() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        if (this.isOpen) return;
        this.isOpen = true;
        if (!this.$element) return;

        this.$element.addClass("admin-toolbar__list--active");

        let $ul = this.$element.find("ul");
        if (this.$element.offset().left + $ul.outerWidth() > $(window).width()) {
            $ul.css({left: "", right: "0"})
        } else {
            $ul.css({left: "0", right: ""})
        }
    }

    getElement() {
        const $element = super.getElement();
        this.$element = $element;

        $element.on("mouseenter", () => {
            if (this.timeout) clearTimeout(this.timeout);
        }).on("mouseleave", () => {
            this.timeout = setTimeout(this.close.bind(this), 200)
        });

        $element.append($("<ul>").append(this.items.map((item) => item.getElement())));

        $element.addClass("admin-toolbar__list");
        if (this.isOpen) {
            $element.addClass("admin-toolbar__list--active")
        }

        return $element;
    }

    close() {
        if (!this.isOpen) return;
        this.isOpen = false;

        if (!this.$element) return;
        this.$element.removeClass("admin-toolbar__list--active")
    }
}

export default ToolbarItemList;
